import { ITenantProfilesHook } from '@models';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

export const useTenantProfiles = (): ITenantProfilesHook => {
  const { tenantProfileStore } = useStore();
  const {
    loading,
    tenantProfiles,
    skipCount,
    totalCount,
    currentPage,
    maxResultCount,
    clearTenantProfiles,
    handlePageChange,
  } = tenantProfileStore;
  const [tenantName, setTenantName] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [zipCode, setZipCode] = useState<string>('');
  const [activity, setActivity] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    return () => clearTenantProfiles();
  }, [clearTenantProfiles]);

  useEffect(() => {
    tenantProfileStore.getAll({
      name: tenantName,
      isActive: activity,
      maxResultCount,
      skipCount,
      zipCode,
      city,
    });
  }, [tenantProfileStore, tenantName, activity, zipCode, city, skipCount, maxResultCount]);

  const handleNameSearch = debounce((text: string) => {
    setTenantName(text);
    tenantProfileStore.setSkipCount(0);
    tenantProfileStore.setCurrentPage(1);
  }, 500);

  const handleCitySearch = debounce((text: string) => {
    setCity(text);
    tenantProfileStore.setSkipCount(0);
    tenantProfileStore.setCurrentPage(1);
  }, 500);

  const handleZipCodeSearch = debounce((text: string) => {
    setZipCode(text);
    tenantProfileStore.setSkipCount(0);
    tenantProfileStore.setCurrentPage(1);
  }, 500);

  return {
    loading,
    dataSource: Array.from(tenantProfiles.values()),
    totalCount,
    handleNameSearch,
    handleCitySearch,
    handleZipCodeSearch,
    currentPage,
    setActivity,
    handlePageChange,
  };
};
